import * as THREE from 'three'
import { onLang } from '../../content/i18n.js'

/**
 * Dile duyarlı kanvas dokuları. Metinler fonksiyonla verilir; dil değişince (ve Space Grotesk
 * yüklenince) doku yeniden çizilir. Kayıt: test ve sayım için tüm dokular.
 */
const FONT_FAMILY = '"Space Grotesk", sans-serif'
export const registry = new Set()

export function fitFont(_context, _text, _weight, _size, _maxWidth)
{
    let size = _size
    do
    {
        _context.font = `${_weight} ${size}px ${FONT_FAMILY}`
        size -= 2
    }
    while(_context.measureText(_text).width > _maxWidth && size > 10)
    return size + 2
}

function localizedCanvas(_width, _height, _draw, _transparent)
{
    const canvas = document.createElement('canvas')
    canvas.width = _width
    canvas.height = _height
    const context = canvas.getContext('2d')
    const texture = new THREE.CanvasTexture(canvas)
    texture.magFilter = THREE.LinearFilter
    texture.minFilter = THREE.LinearMipmapLinearFilter
    texture.anisotropy = 4
    if(_transparent)
    {
        texture.colorSpace = THREE.SRGBColorSpace
    }

    const entry = { texture, renders: 0, minFontSize: Infinity }
    entry.render = () =>
    {
        context.clearRect(0, 0, _width, _height)
        if(!_transparent)
        {
            context.fillStyle = '#000000'
            context.fillRect(0, 0, _width, _height)
        }
        entry.minFontSize = _draw(context) || entry.minFontSize
        texture.needsUpdate = true
        entry.renders++
    }

    entry.render()
    if(document.fonts)
    {
        document.fonts.load(`700 32px "Space Grotesk"`).then(entry.render).catch(() => {})
    }
    onLang(entry.render)
    registry.add(entry)
    texture.userData.entry = entry
    return texture
}

/**
 * Tek satır, alpha dokusu (beyaz = görünür). _getText: () => string
 */
export function lineTexture(_getText, _width = 512, _height = 128)
{
    return localizedCanvas(_width, _height, (_context) =>
    {
        const text = _getText()
        _context.fillStyle = '#ffffff'
        _context.textAlign = 'center'
        _context.textBaseline = 'middle'
        const size = fitFont(_context, text, 700, _height * 0.62, _width * 0.94)
        _context.fillText(text, _width / 2, _height / 2 + 2)
        return size
    })
}

/**
 * İki satır, alpha dokusu: üstte kalın, altta ince (aynı dil).
 */
export function twoLineTexture(_getTop, _getBottom, _width = 1024, _height = 256)
{
    return localizedCanvas(_width, _height, (_context) =>
    {
        _context.fillStyle = '#ffffff'
        _context.textAlign = 'center'
        _context.textBaseline = 'alphabetic'
        const top = fitFont(_context, _getTop(), 700, _height * 0.44, _width * 0.94)
        _context.fillText(_getTop(), _width / 2, _height * 0.5)
        const bottom = fitFont(_context, _getBottom(), 600, _height * 0.26, _width * 0.94)
        _context.fillText(_getBottom(), _width / 2, _height * 0.86)
        return Math.min(top, bottom)
    })
}

/**
 * Renkli satırlar, şeffaf zemin (tabela yüzleri). lines: [{ text: () => string, color, weight, size (0-1), y (0-1) }]
 */
export function signTexture(_lines, _width = 1024, _height = 256)
{
    return localizedCanvas(_width, _height, (_context) =>
    {
        let min = Infinity
        for(const _line of _lines)
        {
            const text = _line.text()
            _context.fillStyle = _line.color
            _context.textAlign = 'center'
            _context.textBaseline = 'middle'
            min = Math.min(min, fitFont(_context, text, _line.weight || 700, _height * _line.size, _width * 0.9))
            _context.fillText(text, _width / 2, _height * _line.y)
        }
        return min
    }, true)
}
